<script>
  export let chats_db;
  export let socket_query;
  export let travel_db;
  export let units_travel_db;
  import { onMount, onDestroy, afterUpdate, tick } from "svelte";
  import {
    units_list,
    nicks_list,
    geos,
    geos_class,
    travels,
    table_pos,
    live,
    drivers_list,
    drivers,
    travels_list,
    poli,
    map_ready,
    group,
  } from "./stores.js";
  import {
    acquirePooledMap,
    createVectorMapOptions,
    MAP_POOL_SLOTS,
    MAP_RESET_VIEW,
    releasePooledMap,
  } from "./map-pool.js";
  import {
    createDriverSearchEntries,
  } from "./driver-search.js";
  import DriverListSearch from "./DriverListSearch.svelte";

  let selected = !localStorage.getItem("selected_driver")
    ? -1
    : parseInt(localStorage.getItem("selected_driver"));
  $: {
    localStorage.setItem("selected_driver", selected);
  }
  let selected_new = -1;
  let driver_search_entries = [];
  let driver_name = "-";
  let tel = "-";
  let chatId = "-";
  let chatType = "-";
  let usuario = "-";
  let inter;
  let inter2;
  let aceleracion = 0,
    frenada = 0,
    exceso = 0,
    vuelta = 0;
  let travels_list_op = [];
  let driver_id = "";
  let photo_file = "img/profile.png";
  let travels_day_km_g = [];
  let q_score = 0;
  let s_score = 0;
  let alerts_security = [
    "4330d447-f21c-468b-b98d-020c23e13b2b",
    "d77ff8f7-37f7-4173-9f15-7d0c41d798d5",
    "d6247ba3-a6f6-4781-a220-e3cc24ec26e8",
    "e5bf3b75-934b-41b4-9a2a-864e8d54c2dd",
  ];
  const DRIVER_HISTORY_WINDOW_SECONDS = 60 * 60 * 24 * 30;
  const DRIVER_HISTORY_LOAD_BATCH = 50;
  let driver_history_loading = false;
  let driver_history_loaded = 0;
  let driver_history_total = 0;
  let driver_history_matches = 0;
  let driver_history_progress = 0;
  let _driverHistoryEpoch = 0;
  let _driverHistoryCacheRevision = 0;
  let _lastHistoryTravelsList;
  let _lastHistoryNicksList;
  let _lastHistoryGeosClass;
  let _lastHistoryPoli;
  const driverHistoryItemCache = new Map();
  const driverHistoryCache = new Map();
  const DRIVER_PHOTO_PLACEHOLDER = "img/profile.png";
  const DRIVER_PHOTO_ACCEPTED_TYPES = new Set([
    "image/jpeg",
    "image/png",
    "image/webp",
  ]);
  const DRIVER_PHOTO_MAX_ORIGINAL_BYTES = 5 * 1024 * 1024;
  const DRIVER_PHOTO_MIN_DIMENSION = 100;
  const DRIVER_PHOTO_CANVAS_SIZE = 320;
  const DRIVER_PHOTO_MAX_PROCESSED_BYTES = 150 * 1024;
  const DRIVER_PHOTO_JPEG_QUALITIES = [0.84, 0.78, 0.72, 0.66, 0.6];
  const SAFETY_SCORE_TOOLTIP =
    "Se calcula comparando los viajes recientes del chofer contra los eventos de manejo detectados en ese periodo. Mientras menos maniobras bruscas o excesos de velocidad haya por viaje, mas alto sera el score.";
  const SECURITY_SCORE_TOOLTIP =
    "Se calcula comparando los viajes recientes del chofer contra las alertas registradas en ese mismo periodo. Mientras menos alertas haya por viaje, mas alto sera el score.";
  const driverPhotoCache = new Map();
  let driver_photo_loading = false;
  let driver_photo_loading_text = "";
  let driver_photo_error = "";
  let driver_photo_payload = null;
  let driver_photo_pending_action = "keep";
  let current_driver_has_photo = false;
  let current_driver_photo_version = "no-photo";
  let driver_list_container;
  let driver_search_header;
  let driver_search_shell;
  let driver_search_resize_observer;
  let mobileSearchOpen = false;
  let compactSearchHeader = false;
  let photoInput;
  let _driverPhotoEpoch = 0;
  let can_remove_driver_photo = false;
  const DRIVER_SEARCH_COMPACT_MAX_WIDTH = 280;
  $: driver_search_entries = createDriverSearchEntries($drivers_list, $drivers);
  async function scrollDriverIntoView(driverId) {
    await tick();
    if (!driver_list_container || !driverId) {
      return;
    }
    const rows = driver_list_container.querySelectorAll("[data-driver-id]");
    for (let index = 0; index < rows.length; index++) {
      const row = rows[index];
      if (row && row.getAttribute("data-driver-id") == driverId) {
        row.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
        return;
      }
    }
  }
  function selectDriverFromSearchEntry(entry) {
    if (!entry) {
      return;
    }
    maping(entry.index, true);
  }

  function updateDriverSearchLayout() {
    const nextCompactSearchHeader =
      driver_search_header != null &&
      driver_search_header.clientWidth > 0 &&
      driver_search_header.clientWidth < DRIVER_SEARCH_COMPACT_MAX_WIDTH;
    compactSearchHeader = nextCompactSearchHeader;
    if (!compactSearchHeader) {
      mobileSearchOpen = false;
    }
  }

  async function toggleMobileSearch(nextState = !mobileSearchOpen) {
    if (!compactSearchHeader) {
      mobileSearchOpen = false;
      return;
    }
    mobileSearchOpen = Boolean(nextState);
    if (!mobileSearchOpen) {
      return;
    }
    await tick();
    const driver_search_input = driver_search_shell
      ? driver_search_shell.querySelector("input[type='search']")
      : null;
    if (driver_search_input) {
      driver_search_input.focus();
      driver_search_input.select();
    }
  }

  $: if (
    $travels_list !== _lastHistoryTravelsList ||
    $nicks_list !== _lastHistoryNicksList ||
    $geos_class !== _lastHistoryGeosClass ||
    $poli !== _lastHistoryPoli
  ) {
    if ($travels_list !== _lastHistoryTravelsList) {
      driverHistoryItemCache.clear();
    }
    _lastHistoryTravelsList = $travels_list;
    _lastHistoryNicksList = $nicks_list;
    _lastHistoryGeosClass = $geos_class;
    _lastHistoryPoli = $poli;
    _driverHistoryCacheRevision = _driverHistoryCacheRevision + 1;
    driverHistoryCache.clear();
  }

  function createDriverHistoryAccumulator() {
    return {
      rows: [],
      dayCounts: {},
      dayKm: {},
      totalKm: 0,
      totalAlerts: 0,
      totalAltSafe: 0,
      aceleracion: 0,
      frenada: 0,
      exceso: 0,
      vuelta: 0,
    };
  }

  function getDriverHistoryProgress(loaded = driver_history_loaded, total = driver_history_total) {
    return total > 0 ? Math.round((loaded / total) * 100) : 0;
  }

  function waitForNextPaint() {
    return new Promise((resolve) => {
      if (
        typeof window !== "undefined" &&
        typeof window.requestAnimationFrame === "function"
      ) {
        window.requestAnimationFrame(() => resolve());
        return;
      }
      setTimeout(resolve, 0);
    });
  }

  async function getTravelHistoryRecord(travelId) {
    if (!travelId) {
      return null;
    }
    if (!driverHistoryItemCache.has(travelId)) {
      driverHistoryItemCache.set(
        travelId,
        (async () => {
          try {
            let travel = await travel_db.getItem(travelId);
            return travel != null ? JSON.parse(travel) : null;
          } catch (e) {
            console.log("Error leyendo travel", e);
            return null;
          }
        })()
      );
    }
    return driverHistoryItemCache.get(travelId);
  }

  function resolveTravelLocationLabel(locationId) {
    return typeof $geos_class[locationId] != "undefined"
      ? $geos_class[locationId][0]
      : typeof $poli[locationId] != "undefined"
        ? $poli[locationId][1]
        : locationId || "-";
  }

  function resolveTravelDestinationLabel(travel, sec_dests) {
    if (sec_dests.length > 0) {
      return resolveTravelLocationLabel(sec_dests[sec_dests.length - 1]);
    }
    return resolveTravelLocationLabel(travel.dest);
  }

  function appendTravelToDriverHistory(accumulator, travel) {
    let alerts = Array.isArray(travel.alerts) ? travel.alerts : [];
    let sec_dests = Array.isArray(travel.sec_dests) ? travel.sec_dests : [];
    let travel_start = Number(travel.start || 0);
    let travel_end = Number(travel.end || travel_start || 0);
    let travel_distance = Number(travel.distance || 0);
    accumulator.rows.push([
      moment(new Date(travel_start * 1000)).format("DD/MM/YY HH:mm"),
      typeof $nicks_list[travel.id] != "undefined"
        ? $nicks_list[travel.id]
        : travel.id,
      resolveTravelLocationLabel(travel.org),
      resolveTravelDestinationLabel(travel, sec_dests),
      time_code_s(travel_end - travel_start),
      alerts.length,
      travel.id,
      travel_start,
      travel_end,
      travel.uuid,
      alerts,
    ]);

    for (let w = 0; w < alerts.length; w++) {
      if (alerts[w] && alerts[w].pos_data) {
        accumulator.totalAlerts = accumulator.totalAlerts + 1;
        if (
          alerts[w].pos_data.event_code == "70" ||
          alerts[w].pos_data.event_code == "71"
        ) {
          accumulator.vuelta = accumulator.vuelta + 1;
        }
        if (alerts[w].pos_data.event_code == "6E") {
          accumulator.aceleracion = accumulator.aceleracion + 1;
        }
        if (alerts[w].pos_data.event_code == "6F") {
          accumulator.frenada = accumulator.frenada + 1;
        }
        if (alerts[w].pos_data.event_code == "5B") {
          accumulator.exceso = accumulator.exceso + 1;
        }
      } else {
        accumulator.totalAltSafe = accumulator.totalAltSafe + 1;
      }
    }

    let travel_day = moment(travel_start * 1000).startOf("day").format("DD/MM/YY");
    accumulator.dayCounts[travel_day] = (accumulator.dayCounts[travel_day] || 0) + 1;
    accumulator.totalKm = accumulator.totalKm + travel_distance;
    accumulator.dayKm[travel_day] = (accumulator.dayKm[travel_day] || 0) + travel_distance;
  }

  function buildDriverHistorySnapshot(accumulator, totalScanned) {
    let dayLabels = [];
    let dayTrips = [];
    let dayKm = [];
    for (let day in accumulator.dayCounts) {
      dayLabels.push(day);
      dayTrips.push(accumulator.dayCounts[day]);
      dayKm.push(Math.round(accumulator.dayKm[day] || 0));
    }
    return {
      rows: accumulator.rows,
      dayLabels,
      dayTrips,
      dayKm,
      totalKm: accumulator.totalKm,
      totalAlerts: accumulator.totalAlerts,
      totalAltSafe: accumulator.totalAltSafe,
      aceleracion: accumulator.aceleracion,
      frenada: accumulator.frenada,
      exceso: accumulator.exceso,
      vuelta: accumulator.vuelta,
      totalScanned,
    };
  }

  function updateDriverHistoryChart(snapshot) {
    travels_day_km_g = [...snapshot.dayKm];
    if (!chart_1) {
      return;
    }
    chart_1.data.labels = [...snapshot.dayLabels].reverse();
    chart_1.data.datasets = [];
    chart_1.data.datasets.push({
      label: "Viajes totales (" + comma(snapshot.totalKm) + " KM)",
      data: [...snapshot.dayTrips].reverse(),
      borderColor: "rgb(54, 162, 235)",
      backgroundColor: "rgb(54, 162, 235)",
      fill: false,
      pointRadius: 0,
      yAxisID: "y-axis-1",
    });
    chart_1.update();
  }

  function applyDriverHistorySnapshot(snapshot) {
    travels_list_op = [...snapshot.rows];
    driver_history_matches = snapshot.rows.length;
    aceleracion = snapshot.aceleracion;
    frenada = snapshot.frenada;
    exceso = snapshot.exceso;
    vuelta = snapshot.vuelta;
    updateDriverHistoryChart(snapshot);
  }

  function resetDriverHistorySnapshot() {
    driver_history_loading = false;
    driver_history_loaded = 0;
    driver_history_total = 0;
    driver_history_matches = 0;
    driver_history_progress = 0;
    travels_list_op = [];
    travels_day_km_g = [];
    aceleracion = 0;
    frenada = 0;
    exceso = 0;
    vuelta = 0;
    q_score = 0;
    s_score = 0;
    score = 0;
    score_b = 0;
    if (chart_1) {
      chart_1.data.labels = [];
      chart_1.data.datasets = [];
      chart_1.update();
    }
  }

  function showTransientMessage(type, text, duration = 3000) {
    saved_type = type;
    saved_text = text;
    saved_ok = true;
    setTimeout(() => {
      saved_ok = false;
    }, duration);
  }

  function setDriverPhotoDisplay(source) {
    photo_file = source || DRIVER_PHOTO_PLACEHOLDER;
  }

  function clearDriverPhotoInput() {
    if (photoInput) {
      photoInput.value = "";
    }
  }

  function invalidateDriverPhotoCache(driverKey) {
    if (!driverKey) {
      return;
    }
    for (let cacheKey of [...driverPhotoCache.keys()]) {
      if (cacheKey.startsWith(driverKey + ":")) {
        driverPhotoCache.delete(cacheKey);
      }
    }
  }

  function resolveInlineDriverPhoto(driverData) {
    return driverData &&
      typeof driverData.photo === "string" &&
      driverData.photo.startsWith("data:image/")
      ? driverData.photo
      : "";
  }

  function buildDriverPhotoVersionFromMeta(driverData = {}, inlinePhoto = "") {
    const updatedAt = Number(driverData.photo_updated_at || 0);
    const bytes = Number(driverData.photo_bytes || 0);
    const mimeType =
      typeof driverData.photo_mime_type === "string"
        ? driverData.photo_mime_type
        : "";
    const hasPhoto =
      Boolean(inlinePhoto) ||
      driverData.has_photo === true ||
      updatedAt > 0 ||
      bytes > 0 ||
      mimeType !== "";

    if (!hasPhoto) {
      return "no-photo";
    }

    return [
      updatedAt > 0 ? updatedAt : 0,
      bytes > 0 ? bytes : 0,
      mimeType,
      inlinePhoto ? "legacy" : "stored",
    ].join(":");
  }

  function getDriverPhotoSavePayload() {
    if (driver_photo_pending_action === "set" && driver_photo_payload) {
      return { ...driver_photo_payload };
    }
    if (driver_photo_pending_action === "remove") {
      return { action: "remove" };
    }
    return null;
  }

  function primeDriverPhotoCache(driverKey, meta, source) {
    if (!driverKey) {
      return;
    }
    const versionKey = buildDriverPhotoVersionFromMeta(meta);
    driverPhotoCache.set(`${driverKey}:${versionKey}`, source || null);
    current_driver_has_photo = meta && meta.has_photo === true;
    current_driver_photo_version = versionKey;
  }

  function getDriverPhotoErrorMessage(errorOrCode) {
    const code =
      typeof errorOrCode === "string"
        ? errorOrCode
        : errorOrCode && errorOrCode.message
          ? errorOrCode.message
          : "";

    switch (code) {
      case "photo_invalid_type":
      case "error_photo_invalid_type":
        return "La foto debe ser JPEG, PNG o WEBP.";
      case "photo_original_too_large":
        return "La imagen original no debe exceder 5 MB.";
      case "photo_too_small":
      case "error_photo_too_small":
        return "La foto debe tener al menos 100x100 píxeles.";
      case "photo_processed_too_large":
      case "error_photo_too_large":
        return "La foto optimizada excede el máximo de 150 KB.";
      case "error_photo_invalid":
      case "photo_invalid":
      default:
        return "No se pudo procesar la foto del chofer.";
    }
  }

  function getDriverSaveErrorMessage(code) {
    if (code === "error1") {
      return "El ChatId ya está asignado a otro chofer.";
    }
    if (typeof code === "string" && code.startsWith("error_photo")) {
      return getDriverPhotoErrorMessage(code);
    }
    return "No se pudo guardar el chofer.";
  }

  function resetDriverPhotoDraft() {
    driver_photo_payload = null;
    driver_photo_pending_action = "keep";
    driver_photo_error = "";
    clearDriverPhotoInput();
  }

  function buildPhotoCacheKey(driverKey, driverData, inlinePhoto = "") {
    return `${driverKey}:${buildDriverPhotoVersionFromMeta(
      driverData,
      inlinePhoto
    )}`;
  }

  async function emitAckAsync(event, ...args) {
    return await new Promise((resolve) => {
      socket_query.emit(event, ...args, (data) => {
        resolve(data);
      });
    });
  }

  async function syncSelectedDriverPhoto(driverKey, driverData) {
    const inlinePhoto = resolveInlineDriverPhoto(driverData);
    const cacheKey = buildPhotoCacheKey(driverKey, driverData, inlinePhoto);
    const loadEpoch = ++_driverPhotoEpoch;
    current_driver_photo_version = cacheKey.split(":").slice(1).join(":");
    current_driver_has_photo = current_driver_photo_version !== "no-photo";
    resetDriverPhotoDraft();
    driver_photo_loading = false;
    driver_photo_loading_text = "";

    if (inlinePhoto) {
      driverPhotoCache.set(cacheKey, inlinePhoto);
      setDriverPhotoDisplay(inlinePhoto);
      return;
    }

    const cachedPhoto = driverPhotoCache.get(cacheKey);
    if (typeof cachedPhoto !== "undefined") {
      setDriverPhotoDisplay(cachedPhoto);
      return;
    }

    if (!current_driver_has_photo) {
      driverPhotoCache.set(cacheKey, null);
      setDriverPhotoDisplay("");
      return;
    }

    driver_photo_loading = true;
    driver_photo_loading_text = "Cargando foto…";
    setDriverPhotoDisplay("");

    const response = await emitAckAsync("driver_photo_get", driverKey);
    if (loadEpoch !== _driverPhotoEpoch || driver_id !== driverKey) {
      return;
    }

    driver_photo_loading = false;
    driver_photo_loading_text = "";

    if (!response || response.status !== "ok") {
      driver_photo_error = "No se pudo cargar la foto del chofer.";
      setDriverPhotoDisplay("");
      return;
    }

    const resolvedPhoto = response.photo || null;
    const responseMeta = {
      has_photo: response.has_photo === true || Boolean(resolvedPhoto),
      photo_updated_at: response.photo_updated_at,
      photo_mime_type: response.photo_mime_type,
      photo_bytes: response.photo_bytes,
    };
    driverPhotoCache.set(cacheKey, resolvedPhoto);
    driverPhotoCache.set(
      `${driverKey}:${buildDriverPhotoVersionFromMeta(responseMeta)}`,
      resolvedPhoto
    );
    current_driver_has_photo = responseMeta.has_photo;
    current_driver_photo_version = buildDriverPhotoVersionFromMeta(responseMeta);
    setDriverPhotoDisplay(resolvedPhoto);
  }

  function fileToDataUrl(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        resolve(event && event.target ? event.target.result : "");
      };
      reader.onerror = () => reject(new Error("photo_invalid"));
      reader.readAsDataURL(file);
    });
  }

  function loadImageFromDataUrl(dataUrl) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = () => reject(new Error("photo_invalid"));
      image.src = dataUrl;
    });
  }

  function canvasToBlob(canvas, type, quality) {
    return new Promise((resolve, reject) => {
      canvas.toBlob(
        (blob) => {
          if (blob) {
            resolve(blob);
            return;
          }
          reject(new Error("photo_processed_too_large"));
        },
        type,
        quality
      );
    });
  }

  async function processDriverPhotoFile(file) {
    if (!file || !DRIVER_PHOTO_ACCEPTED_TYPES.has(file.type)) {
      throw new Error("photo_invalid_type");
    }
    if (file.size > DRIVER_PHOTO_MAX_ORIGINAL_BYTES) {
      throw new Error("photo_original_too_large");
    }

    const sourceDataUrl = await fileToDataUrl(file);
    const image = await loadImageFromDataUrl(sourceDataUrl);
    const width = image.naturalWidth || image.width || 0;
    const height = image.naturalHeight || image.height || 0;
    if (width < DRIVER_PHOTO_MIN_DIMENSION || height < DRIVER_PHOTO_MIN_DIMENSION) {
      throw new Error("photo_too_small");
    }

    const canvas = document.createElement("canvas");
    canvas.width = DRIVER_PHOTO_CANVAS_SIZE;
    canvas.height = DRIVER_PHOTO_CANVAS_SIZE;
    const context = canvas.getContext("2d");
    if (!context) {
      throw new Error("photo_invalid");
    }

    context.fillStyle = "#ffffff";
    context.fillRect(0, 0, canvas.width, canvas.height);
    const scale = Math.min(
      DRIVER_PHOTO_CANVAS_SIZE / width,
      DRIVER_PHOTO_CANVAS_SIZE / height
    );
    const drawWidth = Math.max(1, Math.round(width * scale));
    const drawHeight = Math.max(1, Math.round(height * scale));
    const offsetX = Math.round((DRIVER_PHOTO_CANVAS_SIZE - drawWidth) / 2);
    const offsetY = Math.round((DRIVER_PHOTO_CANVAS_SIZE - drawHeight) / 2);
    context.drawImage(image, offsetX, offsetY, drawWidth, drawHeight);

    for (let quality of DRIVER_PHOTO_JPEG_QUALITIES) {
      const blob = await canvasToBlob(canvas, "image/jpeg", quality);
      if (blob.size <= DRIVER_PHOTO_MAX_PROCESSED_BYTES) {
        return {
          action: "set",
          data_url: await fileToDataUrl(blob),
          mime_type: "image/jpeg",
          bytes: blob.size,
          updated_at: Date.now(),
        };
      }
    }

    throw new Error("photo_processed_too_large");
  }

  async function handleDriverPhotoInputChange(event) {
    const file = event && event.target && event.target.files
      ? event.target.files[0]
      : null;
    if (!file) {
      return;
    }

    const loadEpoch = ++_driverPhotoEpoch;
    driver_photo_loading = true;
    driver_photo_loading_text = "Procesando foto…";
    driver_photo_error = "";

    try {
      const processedPhoto = await processDriverPhotoFile(file);
      if (loadEpoch !== _driverPhotoEpoch) {
        return;
      }
      driver_photo_payload = processedPhoto;
      driver_photo_pending_action = "set";
      driver_photo_loading = false;
      driver_photo_loading_text = "";
      setDriverPhotoDisplay(processedPhoto.data_url);
    } catch (error) {
      if (loadEpoch !== _driverPhotoEpoch) {
        return;
      }
      driver_photo_loading = false;
      driver_photo_loading_text = "";
      driver_photo_error = getDriverPhotoErrorMessage(error);
    }

    clearDriverPhotoInput();
  }

  function openDriverPhotoPicker() {
    if (photoInput) {
      photoInput.click();
    }
  }

  function removeDriverPhoto() {
    _driverPhotoEpoch = _driverPhotoEpoch + 1;
    driver_photo_loading = false;
    driver_photo_loading_text = "";
    driver_photo_error = "";
    driver_photo_payload = null;
    driver_photo_pending_action =
      selected != -1 && current_driver_has_photo ? "remove" : "keep";
    setDriverPhotoDisplay("");
    clearDriverPhotoInput();
  }

  function cancelDriverEdit() {
    _driverPhotoEpoch = _driverPhotoEpoch + 1;
    driver_photo_loading = false;
    driver_photo_loading_text = "";

    if (selected != -1) {
      tel_edit_mode = false;
      maping(selected, true);
      return;
    }

    add_mode = false;
    drivers_add = [];
    selected_new = -1;
    tel_edit_mode = false;
    resetDriverPhotoDraft();
    setDriverPhotoDisplay("");
    current_driver_has_photo = false;
    current_driver_photo_version = "no-photo";
    if ($drivers_list.length > 0) {
      selected = 0;
      maping(0, true);
    }
  }

  function getDriverScore(totalAlerts, totalTravels) {
    if (!totalTravels) {
      return 100;
    }
    let penalty = (totalAlerts / totalTravels) * 0.15;
    penalty = penalty > 1 ? 1 : penalty;
    let scoreValue = parseInt((1 - penalty) * 100);
    if (!Number.isFinite(scoreValue)) {
      return 100;
    }
    return scoreValue == 0 ? 1 : scoreValue;
  }

  function animateDriverScores(totalTravels, totalAlt, totalAltSafe) {
    q_score = getDriverScore(totalAlt, totalTravels);
    s_score = getDriverScore(totalAltSafe, totalTravels);
    score = 0;
    score_b = 0;
    inter = setInterval(() => {
      score < q_score ? (score = score + 1) : clearInterval(inter);
    }, 10);
    inter2 = setInterval(() => {
      score_b < s_score ? (score_b = score_b + 1) : clearInterval(inter2);
    }, 10);
  }

  async function maping(i, manual = false) {
    console.log(
      "maping",
      mapa_on_,
      add_mode,
      drivers_add,
      selected_new,
      tel_edit_mode,
      selected
    );
    if (manual) {
      mobileSearchOpen = false;
      mapa_on_ = false;
      add_mode = false;
      drivers_add = [];
      selected_new = -1;
      tel_edit_mode = false;
      selected = i;
      score = 0;
      score_b = 0;
    }
    if (!$drivers_list[i] || !$drivers[$drivers_list[i][0]]) {
      return 0;
    }
    const selectedDriverId = $drivers_list[i][0];
    const selectedDriver = $drivers[selectedDriverId];
    const historyCacheRevision = _driverHistoryCacheRevision;
    const historyCacheKey = `${selectedDriverId}:${historyCacheRevision}`;
    const historyTravelIds = Array.isArray($travels_list)
      ? [...$travels_list].reverse()
      : [];
    const loadEpoch = ++_driverHistoryEpoch;
    driver_id = selectedDriverId;
    await scrollDriverIntoView(selectedDriverId);
    driver_name =
      typeof selectedDriver.name != "undefined"
        ? selectedDriver.name
        : "";
    tel =
      typeof selectedDriver.tel != "undefined"
        ? selectedDriver.tel
        : "";
    chatId =
      typeof selectedDriver.chatId != "undefined"
        ? selectedDriver.chatId
        : "";
    usuario =
      typeof selectedDriver.user != "undefined"
        ? selectedDriver.user
        : "";
    travels_list_op =
      typeof selectedDriver.travels_list != "undefined"
        ? selectedDriver.travels_list
        : [];
    chatType =
      chatId.search("\\+52") >= 0
        ? "Vector Messenger"
        : typeof selectedDriver.ot_account != "undefined"
          ? "OT Drive"
          : chatId.split("-").length == 5
            ? "Web App"
            : chatId != ""
              ? "Telegram APP"
              : "Ninguno";
    syncSelectedDriverPhoto(selectedDriverId, selectedDriver);
    try {
      clearInterval(inter);
    } catch (e) {
      console.log(e);
    }
    try {
      clearInterval(inter2);
    } catch (e) {
      console.log(e);
    }
    /*
    inter = setInterval(() => {
      score < $drivers[$drivers_list[i][0]].score
        ? (score = score + 1)
        : clearInterval(inter);
    }, 10);
    */
    //chart_1.data.datasets[0].data = $drivers[$drivers_list[i][0]].travels;
    chart_1.update();
    console.log("driver_id", driver_id);

    let cachedHistory = driverHistoryCache.get(historyCacheKey);
    if (cachedHistory) {
      driver_history_loading = false;
      driver_history_loaded = cachedHistory.totalScanned;
      driver_history_total = cachedHistory.totalScanned;
      driver_history_progress = 100;
      applyDriverHistorySnapshot(cachedHistory);
      animateDriverScores(
        cachedHistory.rows.length,
        cachedHistory.totalAlerts,
        cachedHistory.totalAltSafe
      );
      return;
    }

    resetDriverHistorySnapshot();
    driver_history_loading = true;
    driver_history_total = historyTravelIds.length;

    if (historyTravelIds.length == 0) {
      driver_history_loading = false;
      animateDriverScores(0, 0, 0);
      return;
    }

    await tick();

    let accumulator = createDriverHistoryAccumulator();
    let now_time = new Date() / 1000;

    for (
      let offset = 0;
      offset < historyTravelIds.length;
      offset = offset + DRIVER_HISTORY_LOAD_BATCH
    ) {
      if (loadEpoch !== _driverHistoryEpoch) {
        return;
      }

      let batchIds = historyTravelIds.slice(offset, offset + DRIVER_HISTORY_LOAD_BATCH);
      let batchTravels = await Promise.all(
        batchIds.map((travelId) => getTravelHistoryRecord(travelId))
      );

      if (loadEpoch !== _driverHistoryEpoch) {
        return;
      }

      for (let batchIndex = 0; batchIndex < batchTravels.length; batchIndex++) {
        let travel = batchTravels[batchIndex];
        let travel_end = Number(travel && travel.end ? travel.end : 0);
        if (
          travel &&
          travel.oper == selectedDriverId &&
          travel.status == 0 &&
          travel_end > 0 &&
          now_time - travel_end < DRIVER_HISTORY_WINDOW_SECONDS
        ) {
          appendTravelToDriverHistory(accumulator, travel);
        }
      }

      let snapshot = buildDriverHistorySnapshot(
        accumulator,
        Math.min(offset + batchIds.length, historyTravelIds.length)
      );
      driver_history_loaded = snapshot.totalScanned;
      driver_history_total = historyTravelIds.length;
      driver_history_progress = getDriverHistoryProgress(
        snapshot.totalScanned,
        historyTravelIds.length
      );
      applyDriverHistorySnapshot(snapshot);

      await tick();
      if (offset + batchIds.length < historyTravelIds.length) {
        await waitForNextPaint();
      }
    }

    if (loadEpoch !== _driverHistoryEpoch) {
      return;
    }

    let finalSnapshot = buildDriverHistorySnapshot(accumulator, historyTravelIds.length);
    driverHistoryCache.set(historyCacheKey, finalSnapshot);
    driver_history_loaded = historyTravelIds.length;
    driver_history_total = historyTravelIds.length;
    driver_history_progress = 100;
    applyDriverHistorySnapshot(finalSnapshot);
    driver_history_loading = false;
    animateDriverScores(
      finalSnapshot.rows.length,
      finalSnapshot.totalAlerts,
      finalSnapshot.totalAltSafe
    );
  }

  let mapa_on_ = false;
  let map_routes;
  let route_map_host;
  let alert_map_host;
  function initMap() {
    map_routes = acquirePooledMap(
      MAP_POOL_SLOTS.ROUTE_DETAIL,
      "choferes-route-detail",
      route_map_host,
      {
        mapOptions: createVectorMapOptions({
          fullscreenControl: false,
        }),
        resetView: MAP_RESET_VIEW.MEXICO_BOUNDS,
      }
    );
  }

  function cleanup_choferes_route_map() {
    if (ruta_real) {
      ruta_real.setMap(null);
      ruta_real = undefined;
    }

    if (m_inicio) {
      m_inicio.setMap(null);
      m_inicio = undefined;
    }

    if (m_fin) {
      m_fin.setMap(null);
      m_fin = undefined;
    }

    for (let marker of m_pause) {
      if (marker) {
        marker.setMap(null);
      }
    }
    m_pause = [];
    map_routes = undefined;
  }

  function cleanup_choferes_alert_map() {
    for (let marker of alert_marks) {
      if (marker) {
        marker.setMap(null);
      }
    }
    alert_marks = [];
    selected_alert = -1;
    map_alerts = undefined;
  }

  onDestroy(() => {
    _driverHistoryEpoch = _driverHistoryEpoch + 1;
    _driverPhotoEpoch = _driverPhotoEpoch + 1;
    try {
      clearInterval(inter);
    } catch (e) {
      console.log(e);
    }

    try {
      clearInterval(inter2);
    } catch (e) {
      console.log(e);
    }

    releasePooledMap(
      MAP_POOL_SLOTS.ROUTE_DETAIL,
      "choferes-route-detail",
      cleanup_choferes_route_map
    );
    releasePooledMap(
      MAP_POOL_SLOTS.ALERT_DETAIL,
      "choferes-alert-detail",
      cleanup_choferes_alert_map
    );
  });

  $: {
    if (!detalle_modal) {
      releasePooledMap(
        MAP_POOL_SLOTS.ALERT_DETAIL,
        "choferes-alert-detail",
        cleanup_choferes_alert_map
      );
    }
  }

  $: {
    if ($map_ready == 1 && mount_complete && route_map_host != null && !map_routes) {
      initMap();
      console.log("mapa cargado");
    }
  }

  let bounds;
  let ruta_real;
  let m_inicio;
  let m_fin;
  let fecha_now = "";
  let unidad_now = "";
  let origen_now = "";
  let destino_now = "";
  let duracion_now = "";
  let alertas_now = "";
  let time_travel = 0;
  let time_idle = 0;
  let time_off = 0;
  let m_pause = [];
  let paradas_now = 0;
  let total_dist = 0;
  async function get_travel(id, start, end, full) {
    total_dist = 0;
    fecha_now = full[0];
    unidad_now = full[1];
    origen_now = full[2];
    destino_now = full[3];
    duracion_now = full[4];
    alertas_now = full[5];
    mapa_on_ = true;
    map_routes.setCenter({ lat: 24.458489, lng: -102.217231 });
    let travel = { id: id, start: start, end: end };
    bounds = new google.maps.LatLngBounds();
    let coordenada_real = [];
    let last_coordenada_real = 0;
    let last_x = -1;
    let last_state = 2;
    let last_state_ = -1;
    let grap_hos = [];
    let grap_hos_c = -1;
    let last_grap_hos_c = -1;
    time_travel = 0;
    time_idle = 0;
    time_off = 0;
    let last_time_travel = 0;
    let last_time_idle = 0;
    let last_time_off = 0;
    let pause_list = [];
    if (typeof travel.start != "undefined") {
      last_coordenada_real = travel.start;
      let rec_p = JSON.parse(await units_travel_db.getItem(travel.id));
      //console.log(rec_p);
      for (var x in rec_p) {
        if (typeof rec_p[x]["p"] != "undefined") {
          for (var w in rec_p[x]["p"]) {
            if (
              rec_p[x]["ds"] + rec_p[x]["p"][w][3] * 60 > travel.start &&
              (typeof travel.end == "undefined" ||
                rec_p[x]["ds"] + rec_p[x]["p"][w][3] * 60 <= travel.end)
            ) {
              let lat = (rec_p[x]["ps"][0] - rec_p[x]["p"][w][0]) / 10000;
              let lng = (rec_p[x]["ps"][1] - rec_p[x]["p"][w][1]) / 10000;
              if (coordenada_real.length > 0) {
                total_dist =
                  total_dist +
                  get_km(
                    coordenada_real[coordenada_real.length - 1].lat,
                    coordenada_real[coordenada_real.length - 1].lng,
                    lat,
                    lng
                  );
              }
              coordenada_real.push({ lat: lat, lng: lng });
              last_coordenada_real = rec_p[x]["ds"] + rec_p[x]["p"][w][3] * 60;
              bounds.extend({ lat: lat, lng: lng });
              if (last_x != x) {
                grap_hos_c++;
                grap_hos.push([]);
                last_x = x;
              }
              if (rec_p[x]["p"].length - 1 == parseInt(w)) {
                last_state = 2;
              } else if (typeof rec_p[x]["p"][w][4] != "undefined") {
                if (rec_p[x]["p"][w][4] > 10) {
                  pause_list.push({ lat: lat, lng: lng });
                  last_state = 1;
                } else {
                  last_state = 0;
                }
              } else {
                last_state = 0;
              }
              if (last_state_ != last_state) {
                if (last_state_ == 2) {
                  last_time_off =
                    last_time_off == 0
                      ? rec_p[x]["ds"] + rec_p[x]["p"][w][3] * 60
                      : last_time_off;
                  time_off =
                    time_off +
                    (rec_p[x]["ds"] + rec_p[x]["p"][w][3] * 60 - last_time_off);
                }
                if (last_state_ == 1) {
                  last_time_idle =
                    last_time_idle == 0
                      ? rec_p[x]["ds"] + rec_p[x]["p"][w][3] * 60
                      : last_time_idle;
                  time_idle =
                    time_idle +
                    (rec_p[x]["ds"] +
                      rec_p[x]["p"][w][3] * 60 -
                      last_time_idle);
                }
                if (last_state_ == 0) {
                  last_time_travel =
                    last_time_travel == 0
                      ? rec_p[x]["ds"] + rec_p[x]["p"][w][3] * 60
                      : last_time_travel;
                  time_travel =
                    time_travel +
                    (rec_p[x]["ds"] +
                      rec_p[x]["p"][w][3] * 60 -
                      last_time_travel);
                }
                last_time_off = rec_p[x]["ds"] + rec_p[x]["p"][w][3] * 60;
                last_time_idle = rec_p[x]["ds"] + rec_p[x]["p"][w][3] * 60;
                last_time_travel = rec_p[x]["ds"] + rec_p[x]["p"][w][3] * 60;
                last_state_ = last_state;
                grap_hos[grap_hos_c].push({
                  y: last_state,
                  t: (rec_p[x]["ds"] + rec_p[x]["p"][w][3] * 60) * 1000,
                });
                if (grap_hos_c > 0 && grap_hos_c != last_grap_hos_c) {
                  last_grap_hos_c = grap_hos_c;
                  grap_hos[grap_hos_c - 1].push({
                    y: last_state,
                    t: (rec_p[x]["ds"] + rec_p[x]["p"][w][3] * 60) * 1000,
                  });
                }
              }
            }
          }
        }
      }
    }
    chart_3.data.datasets[0].data[0] = time_travel;
    chart_3.data.datasets[0].data[1] = time_off;
    chart_3.data.datasets[0].data[2] = time_idle;
    chart_3.update();

    console.log("grap_hos", grap_hos);
    if (coordenada_real.length > 0) {
      map_routes.setZoom(5);
      map_routes.fitBounds(bounds);
    } else {
      map_routes.setZoom(5);
      map_routes.setCenter({ lat: 24.458489, lng: -102.217231 });
    }
    let zIndex = 0;
    if (typeof ruta_real != "undefined") {
      ruta_real.setMap(null);
    }
    ruta_real = new google.maps.Polyline({
      path: coordenada_real,
      geodesic: true,
      strokeColor: "#FF0000",
      strokeOpacity: 1.0,
      strokeWeight: 2.5,
      map: map_routes,
      zIndex: zIndex,
      icons: [
        {
          icon: {
            path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
            strokeColor: "#FF0000",
          },
          offset: "100px",
          repeat: "100px",
        },
      ],
    });
    zIndex++;
    if (typeof m_inicio != "undefined") {
      m_inicio.setMap(null);
    }
    m_inicio = new google.maps.Marker({
      position: coordenada_real[0],
      map: map_routes,
      animation: google.maps.Animation.DROP,
      icon: "img/dd-start.png",
      zIndex: zIndex,
    });

    zIndex++;
    if (typeof m_fin != "undefined") {
      m_fin.setMap(null);
    }
    m_fin = new google.maps.Marker({
      position: coordenada_real[coordenada_real.length - 1],
      map: map_routes,
      animation: google.maps.Animation.DROP,
      icon: "img/dd-end.png",
      zIndex: zIndex,
    });

    zIndex++;
    for (let w in m_pause) {
      if (typeof m_pause[w] != "undefined") {
        m_pause[w].setMap(null);
      }
    }
    m_pause = [];
    for (let z in pause_list) {
      m_pause[z] = new google.maps.Marker({
        position: pause_list[z],
        animation: google.maps.Animation.DROP,
        map: map_routes,
        icon: "img/dd-pause.png",
        zIndex: 0,
      });
    }
    paradas_now = pause_list.length;

    chart_2.data.datasets = [];
    for (let x in grap_hos) {
      chart_2.data.datasets.push({
        label: "Recorrido " + x,
        fill: true,
        borderColor: colors_line[x],
        backgroundColor: color_sombra[x],
        steppedLine: true,
        data: grap_hos[x],
      });
    }
    chart_2.update();
  }

  let coordenada_alertas = [];
  let bounds_alerts;
  function get_alerts(id, alerts) {
    coordenada_alertas = [];
    alert_list_modal = [];
    bounds_alerts = new google.maps.LatLngBounds();
    for (let x in alerts) {
      alert_list_modal.push([
        [
          moment(new Date(alerts[x].alerts_crtl.date_on * 1000)).format(
            "DD/MM/YY HH:mm"
          ),
        ],
        [alerts[x].alerts.name],
        {
          lat: alerts[x].pos_data.lat,
          lng: alerts[x].pos_data.lon,
        },
      ]);
      coordenada_alertas.push({
        lat: alerts[x].pos_data.lat,
        lng: alerts[x].pos_data.lon,
      });
      bounds_alerts.extend({
        lat: alerts[x].pos_data.lat,
        lng: alerts[x].pos_data.lon,
      });
    }
    alert_list_modal = [...alert_list_modal];
    detalle_modal = true;
  }

  function maping_new(i) {
    selected_new = i;
  }
  let score = 0;
  let score_b = 0;

  var chart1 = {
    type: "bar",
    data: {
      labels: [],
      datasets: [],
    },
    plugins: [ChartDataLabels],
    options: {
      plugins: {
        datalabels: {
          color: "white",
          font: { size: "12" },
          formatter: function (value, context) {
            return (
              comma(
                travels_day_km_g[
                  travels_day_km_g.length - 1 - context.dataIndex
                ]
              ) + " km"
            );
          },
        },
      },
      scales: {
        xAxes: [
          {
            gridLines: {
              offsetGridLines: true,
            },
          },
        ],
        yAxes: [
          {
            type: "linear",
            display: true,
            position: "left",
            id: "y-axis-1",
            ticks: {
              beginAtZero: true,
              callback: function (value) {
                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              },
            },
            scaleLabel: {
              display: true,
              labelString: "Numero de viajes",
            },
            offset: true,
          },
          /*
          {
            type: "linear",
            display: true,
            position: "right",
            id: "y-axis-2",
            ticks: {
              beginAtZero: true,
              callback: function (value) {
                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              },
            },
            scaleLabel: {
              display: true,
              labelString: "Distancia (Km)",
            },
            offset: true,
          }
          */
        ],
      },
      title: {
        display: true,
        fontSize: 12,
        padding: 3,
        text: "Viajes completados",
      },
      maintainAspectRatio: false,
      legend: {
        display: false,
      },
    },
  };

  let chart2 = {
    type: "line",
    data: {
      datasets: [
        {
          label: "Recorrido 1",
          data: [
            { y: 2, t: 1579908586980 },
            { y: 1, t: 1579909586980 },
            { y: 0, t: 1579910586980 },
            { y: 0, t: 1579912586980 },
            { y: 0, t: 1579913586980 },
            { y: 1, t: 1579914586980 },
            { y: 2, t: 1579915586980 },
            { y: 2, t: 1579916586980 },
          ],
          fill: true,
          borderColor: "#2196f3",
          backgroundColor: "#e3f2fd",
          steppedLine: true,
        },
        {
          label: "Recorrido 2",
          data: [
            { y: 2, t: 1579916586980 },
            { y: 2, t: 1579917586980 },
            { y: 1, t: 1579918586980 },
            { y: 0, t: 1579919586980 },
            { y: 0, t: 1579920586980 },
            { y: 0, t: 1579921586980 },
            { y: 1, t: 1579922586980 },
            { y: 2, t: 1579923586980 },
            { y: 2, t: 1579924586980 },
          ],
          fill: true,
          borderColor: "#e91e63",
          backgroundColor: "#ffebee",
          steppedLine: true,
        },
      ],
    },
    options: {
      onClick: function (d) {
        let e = chart_2.getElementAtEvent(d);
      },
      tooltips: {
        enabled: true,
        callbacks: {
          label: function (tooltipItem, data) {
            var label = data.datasets[tooltipItem.datasetIndex].label;
            let c =
              tooltipItem.yLabel == 0
                ? "Drive"
                : tooltipItem.yLabel == 1
                  ? "Ilde"
                  : "Off";
            return c;
          },
        },
      },
      title: {
        display: false,
        fontSize: 12,
        padding: 0,
        text: "HOS",
      },
      legend: {
        display: false,
      },
      layout: {
        padding: {
          top: 30,
          right: 20,
        },
      },
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              stepSize: 1,
              callback: function (value, index, values) {
                return value == 0 ? "Drive" : value == 1 ? "Idle" : "Off";
              },
            },
          },
        ],
        xAxes: [
          {
            type: "time",
            time: {
              displayFormats: {
                minute: "HH:mm",
              },
            },
          },
        ],
      },
    },
  };

  var chart3 = {
    type: "pie",
    data: {
      labels: ["On", "Off", "Idle"],
      datasets: [
        {
          data: [10, 10, 20],
          backgroundColor: ["#90caf9", "#ff6090", "#9a67ea"],
        },
      ],
    },
    options: {
      maintainAspectRatio: false,
      legend: {
        display: true,
      },
      tooltips: {
        enabled: true,
        callbacks: {
          label: function (tooltipItem, data) {
            var label = data.labels[tooltipItem.index];
            var val =
              data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            return label + ": " + time_code_s(val);
          },
        },
      },
    },
  };

  let chart_1, chart_2, chart_3, bar1;
  let mount_complete = false;
  onMount(() => {
    updateDriverSearchLayout();
    if (typeof ResizeObserver === "function") {
      driver_search_resize_observer = new ResizeObserver(() => {
        updateDriverSearchLayout();
      });
      if (driver_search_header) {
        driver_search_resize_observer.observe(driver_search_header);
      }
      return () => {
        driver_search_resize_observer.disconnect();
      };
    }
    if (typeof window !== "undefined") {
      window.addEventListener("resize", updateDriverSearchLayout);
      return () => {
        window.removeEventListener("resize", updateDriverSearchLayout);
      };
    }
    return undefined;
  });
  onMount(() => {
    chart_1 = new Chart(
      document.getElementById("chart1").getContext("2d"),
      chart1
    );
    chart_2 = new Chart(
      document.getElementById("chart2").getContext("2d"),
      chart2
    );
    chart_3 = new Chart(
      document.getElementById("chart3").getContext("2d"),
      chart3
    );
    mount_complete = true;
  });
  $: {
    $drivers_list;
    $travels_list;
    $nicks_list;
    $geos_class;
    $poli;
    mount_complete;
    refresh_change();
  }
  function refresh_change() {
    if (tel_edit_mode) {
      return;
    }
    if (selected != -1 && mount_complete && $drivers_list.length > 0) {
      maping(selected);
    } else if ($drivers_list.length > 0 && mount_complete) {
      selected = 0;
      maping(0);
    }
  }
  let drivers_add = [];
  let add_mode = false;
  function add_driver() {
    selected = -1;
    if (drivers_add.length == 0) {
      drivers_add.push([]);
      drivers_add = [...drivers_add];
      add_mode = true;

      driver_name = "";
      password_new = "";
      driver_id = "";
      tel = "";
      tel_new = "";
      chatId = "";
      chatId_new = "";
      chatType = "";
      usuario = "";
      usuario_new = "";
      resetDriverPhotoDraft();
      driver_photo_loading = false;
      driver_photo_loading_text = "";
      current_driver_has_photo = false;
      current_driver_photo_version = "no-photo";
      setDriverPhotoDisplay("");
      tel_edit_mode = true;
      _driverHistoryEpoch = _driverHistoryEpoch + 1;
      _driverPhotoEpoch = _driverPhotoEpoch + 1;
      resetDriverHistorySnapshot();

      selected_new = 0;
    }
  }
  let tel_edit_mode = false;
  let tel_new, chatId_new, usuario_new;
  let password_new = "•••••••••";
  let saved_ok = false,
    saved_type,
    saved_text;
  $: can_remove_driver_photo =
    driver_photo_pending_action === "set" ||
    (selected != -1 && current_driver_has_photo);
  function edit_tel() {
    if (selected != -1) {
      tel_new = tel;
      chatId_new = chatId;
      usuario_new = usuario;
      tel_edit_mode = true;
      password_new = "•••••••••";
      resetDriverPhotoDraft();
    }
  }
  function save_driver() {
    if (driver_photo_loading) {
      showTransientMessage(
        "alert-warning",
        "Espera a que termine la carga o procesamiento de la foto."
      );
      return 0;
    }
    if (!driver_name || driver_name.trim() === "") {
      showTransientMessage("alert-danger", "Ingresa el nombre del chofer.");
      return 0;
    }

    const passwordToSave = password_new == "•••••••••" ? "" : password_new;
    const photoPayload = getDriverPhotoSavePayload();

    if (selected != -1) {
      socket_query.emit(
        "save_driver",
        driver_id,
        tel_new,
        chatId_new,
        usuario_new,
        passwordToSave,
        driver_name,
        photoPayload,
        (data) => {
          if (data == "ok") {
            if (driver_photo_pending_action === "set" && driver_photo_payload) {
              primeDriverPhotoCache(driver_id, {
                has_photo: true,
                photo_updated_at: driver_photo_payload.updated_at,
                photo_mime_type: driver_photo_payload.mime_type,
                photo_bytes: driver_photo_payload.bytes,
              }, driver_photo_payload.data_url);
            } else if (driver_photo_pending_action === "remove") {
              invalidateDriverPhotoCache(driver_id);
              current_driver_has_photo = false;
              current_driver_photo_version = "no-photo";
              setDriverPhotoDisplay("");
            }
            resetDriverPhotoDraft();
            tel_edit_mode = false;
            showTransientMessage("alert-success", "Chofer guardado");
          } else {
            if (typeof data === "string" && data.startsWith("error_photo")) {
              driver_photo_error = getDriverPhotoErrorMessage(data);
            }
            showTransientMessage("alert-danger", getDriverSaveErrorMessage(data));
          }
        }
      );
    }
    if (selected_new != -1 && selected == -1) {
      socket_query.emit(
        "new_driver",
        driver_name,
        tel_new,
        chatId_new,
        usuario_new,
        passwordToSave,
        photoPayload,
        (data) => {
          if (data == "ok") {
            resetDriverPhotoDraft();
            setDriverPhotoDisplay("");
            current_driver_has_photo = false;
            current_driver_photo_version = "no-photo";
            tel_edit_mode = false;
            drivers_add = [];
            add_mode = false;
            selected_new = -1;
            showTransientMessage("alert-success", "Chofer guardado");
          } else {
            if (typeof data === "string" && data.startsWith("error_photo")) {
              driver_photo_error = getDriverPhotoErrorMessage(data);
            }
            showTransientMessage("alert-danger", getDriverSaveErrorMessage(data));
          }
        }
      );
    }
  }
  $: {
    // change usuario_new to miusculas
    if (usuario_new) {
      usuario_new = usuario_new.toLowerCase();
    }
  }
  $: {
    driver_name;
    if (true) {
      if (selected_new != -1 || selected != -1) {
        usuario_new = driver_name.toLowerCase().replace(/ /g, "");
      }
    }
  }
  function time_code_s(time) {
    //if(time<60){return moment.utc().subtract(1, 'years').startOf('years').add({ seconds: time }).format('s[s]')} // 's[s]'
    if (time < 60) {
      return "0m";
    } else if (time < 3600) {
      return moment
        .utc()
        .subtract(1, "years")
        .startOf("years")
        .add({ seconds: time })
        .format("m[min]");
    } else if (time < 86400) {
      return moment
        .utc()
        .subtract(1, "years")
        .startOf("years")
        .add({ seconds: time })
        .format("H[h] m[min]");
    } else if (time < 7776000) {
      return moment
        .utc()
        .subtract(1, "years")
        .startOf("years")
        .add({ seconds: time })
        .format("D[d] H[h] m[min]");
    } else {
      return "+3 meses";
    }
  }
  let colors_line = [
    "#2196f3",
    "#e91e63",
    "#03a9f4",
    "#9c27b0",
    "#00bcd4",
    "#673ab7",
    "#009688",
    "#3f51b5",
    "#4caf50",
    "#ff5722",
    "#8bc34a",
    "#ff9800",
    "#cddc39",
    "#ffc107",
    "#607d8b",
    "#ffeb3b",
    "#9e9e9e",
    "#212121",
    "#f44336",
  ];
  let color_sombra = [
    "#e3f2fd",
    "#fce4ec",
    "#e1f5fe",
    "#f3e5f5",
    "#e0f7fa",
    "#ede7f6",
    "#e0f2f1",
    "#e8eaf6",
    "#e8f5e9",
    "#fbe9e7",
    "#f1f8e9",
    "#fff3e0",
    "#f9fbe7",
    "#fff8e1",
    "#eceff1",
    "#fffde7",
    "#fafafa",
    "#fafafa",
    "#ffebee",
  ];

  let detalle_modal = false;
  let alert_list_modal = [];
  let selected_alert = -1;
  let map_alerts;
  let alert_marks = [];
  async function show_detalle_map() {
    selected_alert = -1;
    await tick();
    map_alerts = acquirePooledMap(
      MAP_POOL_SLOTS.ALERT_DETAIL,
      "choferes-alert-detail",
      alert_map_host,
      {
        mapOptions: createVectorMapOptions({
          fullscreenControl: false,
          maxZoom: 16,
        }),
        resetView: MAP_RESET_VIEW.MEXICO_BOUNDS,
      }
    );
    if (!map_alerts) {
      return;
    }
    for (let z in alert_marks) {
      if (typeof alert_marks[z] != "undefined") {
        alert_marks[z].setMap(null);
      }
    }
    alert_marks = [];
    for (let x in coordenada_alertas) {
      alert_marks[x] = new google.maps.Marker({
        position: coordenada_alertas[x],
        map: map_alerts,
        animation: google.maps.Animation.DROP,
        icon: "img/markerAlt.png",
        zIndex: 1,
      });
    }
    if (bounds_alerts && !bounds_alerts.isEmpty()) {
      map_alerts.fitBounds(bounds_alerts);
    }
  }
  function maping_alert(i) {
    selected_alert = i;
    map_alerts.panTo(alert_list_modal[i][2]);
    alert_marks[i].setMap(null);
    alert_marks[i].setAnimation(google.maps.Animation.DROP);
    alert_marks[i].setMap(map_alerts);
    map_alerts.setZoom(16);
  }
  function get_km(lat1, lon1, lat2, lon2) {
    var R = 6371;
    var dLat = (lat2 - lat1) * (Math.PI / 180);
    var dLon = (lon2 - lon1) * (Math.PI / 180);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * (Math.PI / 180)) *
        Math.cos(lat2 * (Math.PI / 180)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
  }
  function comma(x) {
    try {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } catch (e) {
      return x;
    }
  }
  let f_score = 0;
  function change_score() {
    f_score = f_score == 0 ? 1 : 0;
    score = 0;
    score_b = 0;
    inter = setInterval(() => {
      score < q_score ? (score = score + 1) : clearInterval(inter);
    }, 10);
    inter2 = setInterval(() => {
      score_b < s_score ? (score_b = score_b + 1) : clearInterval(inter2);
    }, 10);
  }
  // Descargar excel
  function loadScript(url) {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = url;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Error loading script: ${url}`));
      document.body.appendChild(script);
    });
  }
  loadScript(
    "https://cdnjs.cloudflare.com/ajax/libs/exceljs/4.4.0/exceljs.min.js"
  );
  async function generarExcel() {
    // 1. Crear un nuevo libro de trabajo
    let workbook;
    try {
      workbook = new ExcelJS.Workbook();
    } catch (error) {
      await loadScript(
        "https://cdnjs.cloudflare.com/ajax/libs/exceljs/4.4.0/exceljs.min.js"
      );
      workbook = new ExcelJS.Workbook();
    }

    // 2. Agregar hojas
    const conductores = workbook.addWorksheet("Conductores");
    const version = workbook.addWorksheet("Version");
    const instrucciones = workbook.addWorksheet("Instrucciones");

    // Agregar los datos
    const data = [
      ["Reglas a seguir"],
      ["1", "Son necesarios nombre, usuario y password para usuarios nuevos"],
      [
        "2",
        "No rellenar el ChatID en caso de usuarios nuevos o existentes para el uso de WebApp",
      ],
      [
        "3",
        "Para realizar actualizaciones continuas, descargar ultima version que tengan ID",
      ],
      [
        "4",
        "En caso de no querer remplazar el password no cambiar los simbolos ●●●●●●●●",
      ],
      ["5", "El telefono no es obligatorio en ningun caso"],
      [
        "6",
        "La lista es unica, por lo que los que no esten en la lista serán borrados",
      ],
    ];

    data.forEach((row) => instrucciones.addRow(row));

    // -----------------------------------------------------
    // Ajustar ancho de columnas en la hoja principal
    // -----------------------------------------------------
    conductores.getColumn(1).width = 40; // ID
    conductores.getColumn(2).width = 20; // Nombre
    conductores.getColumn(3).width = 30; // Usuario
    conductores.getColumn(4).width = 20; // teléfono
    conductores.getColumn(5).width = 20; // password
    conductores.getColumn(6).width = 40; // chatId

    conductores.getColumn(1).style = { numFmt: "@" };
    conductores.getColumn(2).style = { numFmt: "@" };
    conductores.getColumn(3).style = { numFmt: "@" };
    conductores.getColumn(4).style = { numFmt: "@" };
    conductores.getColumn(5).style = { numFmt: "@" };
    conductores.getColumn(6).style = { numFmt: "@" };

    conductores.getCell(1, 1).value = "ID";
    conductores.getCell(1, 2).value = "Nombre";
    conductores.getCell(1, 3).value = "Usuario (_@" + $group + ")";
    conductores.getCell(1, 4).value = "Teléfono";
    conductores.getCell(1, 5).value = "Password";
    conductores.getCell(1, 6).value = "ChatId";

    console.log($drivers_list);
    for (let x = 0; x < $drivers_list.length; x++) {
      conductores.getCell(x + 2, 1).value = $drivers_list[x][0];
      conductores.getCell(x + 2, 2).value = $drivers_list[x][1].name;
      conductores.getCell(x + 2, 3).value = $drivers_list[x][1].user;
      conductores.getCell(x + 2, 4).value = $drivers_list[x][1].tel;
      conductores.getCell(x + 2, 5).value = "•••••••••";
      conductores.getCell(x + 2, 6).value = $drivers_list[x][1].chatId;
    }

    version.getCell(1, 1).value = "Version";
    version.getCell(1, 2).value = "7.36";
    version.state = "hidden";

    // 6. Exportar el archivo Excel y forzar la descarga
    try {
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);

      // Crear un enlace temporal para forzar la descarga
      const a = document.createElement("a");
      a.href = url;
      a.download =
        "Coductores_Vector_" +
        new Date()
          .toISOString()
          .replace(/[-:.]/g, "")
          .replace("T", "_")
          .split(".")[0] +
        ".xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error al generar o descargar el Excel:", error);
    }

    file_drop = true;
    setTimeout(() => {
      file_drop = false;
    }, 3000);
  }
  function emitAsync(event, ...args) {
    return new Promise((resolve, reject) => {
      socket_query.emit(event, ...args, (data) => {
        if (data === "ok") {
          resolve(data);
        } else {
          resolve("error");
        }
      });
    });
  }
  let file_drop = false;
  function upload_conductores(event) {
    event.preventDefault();
    let file = event.dataTransfer.files[0];
    if (!file) return;
    let reader = new FileReader();
    reader.onload = async function (e) {
      file_drop = false;
      let data = new Uint8Array(e.target.result);
      let workbook;
      try {
        workbook = new ExcelJS.Workbook();
      } catch (error) {
        await loadScript(
          "https://cdnjs.cloudflare.com/ajax/libs/exceljs/4.4.0/exceljs.min.js"
        );
        workbook = new ExcelJS.Workbook();
      }
      try {
        await workbook.xlsx.load(data);
      } catch (error) {
        saved_type = "alert-danger";
        saved_text = "El archivo no es un archivo Excel válido";
        saved_ok = true;
        setTimeout(function () {
          saved_ok = false;
        }, 3000);
        return;
      }
      let version_file;
      try {
        // Get sheet named "Version"
        let sheet_version = workbook.getWorksheet("Version");
        version_file = sheet_version.getRow(1).getCell(2).value;
        console.log("version file", version_file);
      } catch (error) {
        saved_type = "alert-danger";
        saved_text = "El archivo no tiene una versión válida";
        saved_ok = true;
        setTimeout(function () {
          saved_ok = false;
        }, 5000);
        return;
      }
      if (version_file != "7.36") {
        saved_type = "alert-danger";
        saved_text = "La versión del archivo no coincide con la versión actual";
        saved_ok = true;
        setTimeout(function () {
          saved_ok = false;
        }, 5000);
        return;
      }
      let sheet = workbook.getWorksheet("Conductores");
      let drivers = [];
      for (let x = 2; x <= sheet.rowCount; x++) {
        let driver = {
          id: sheet.getRow(x).getCell(1).value,
          name: sheet.getRow(x).getCell(2).value,
          user: sheet.getRow(x).getCell(3).value,
          tel: sheet.getRow(x).getCell(4).value,
          password: sheet.getRow(x).getCell(5).value,
          chatId: sheet.getRow(x).getCell(6).value,
        };
        drivers.push(driver);
      }
      console.log(drivers);
      let w = await emitAsync("new_list_driver", drivers);
      if (w == "ok") {
        saved_type = "alert-success";
        saved_text = "Conductores guardados";
        saved_ok = true;
        setTimeout(function () {
          saved_ok = false;
        }, 3000);
      } else {
        saved_type = "alert-danger";
        saved_text = "Error al guardar los conductores";
        saved_ok = true;
        setTimeout(function () {
          saved_ok = false;
        }, 3000);
      }
    };
    reader.readAsArrayBuffer(file);
  }
</script>

{#if detalle_modal}
  <div
    class="modal fade {detalle_modal ? 'show' : ''}"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modaltitle"
    aria-hidden="true"
    style="padding-right: 17px; display: {detalle_modal
      ? 'block'
      : 'none'}; z-index:1039;"
    use:show_detalle_map
  >
    <div
      class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable"
      role="document"
      style="min-width: 95%"
    >
      <div class="modal-content" style="min-height: 99%">
        <div class="modal-header">
          <h5 class="modal-title text-center" id="modaltitle">
            <i class="material-icons bblue md-2">warning</i> Detalle de alertas
            <strong />
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            on:click={() => {
              detalle_modal = false;
            }}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body h-100 p-0">
          <div class="row h-100 no-gutters">
            <div class="col-9 h-100">
              <div class="h-100" bind:this={alert_map_host} />
            </div>
            <div class="col-3 h-100">
              <div class="card h-100 bg-light card-b">
                <div class="d-flex flex-column h-100">
                  <div class="card-header bg-dark text-white b-0">
                    <i tooltip="Reportes" class="material-icons md-90"
                      >report_problem</i
                    > Alertas
                  </div>
                  <div class="card-body flex-grow-1 overflow-auto">
                    <div class="list-group">
                      {#each alert_list_modal as item, i}
                        <a
                          href="/"
                          class:list-group-item-warning={selected_alert == i}
                          class:active_={selected_alert == i}
                          on:click|preventDefault={() => {
                            maping_alert(i);
                          }}
                          class="list-group-item list-group-item-action"
                          ><strong>{item[0]}</strong> | {item[1]}</a
                        >
                      {/each}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" style="z-index:1038" />
{/if}

{#if saved_ok}
  <div class="alert-top alert {saved_type} mb-0 text-center" role="alert">
    <strong>{saved_text}</strong>
  </div>
{/if}

<main
  role="main"
  class="container-fluid h-100 pl-0 pr-0 mdc-top-app-bar--dense-fixed-adjust mdc-typography"
>
  <div class="row h-100 no-gutters">
    <div class="col-2 h-100">
      <div class="card h-100 bg-light card-b">
        <div class="d-flex flex-column h-100">
          <div
            class="card-header bg-dark text-white b-0"
            style="padding-right: 0.2rem;min-height: 39px;"
          >
            <div
              class="driver-search-header"
              class:driver-search-header--compact={compactSearchHeader}
              class:driver-search-header--compact-open={compactSearchHeader &&
                mobileSearchOpen}
              bind:this={driver_search_header}
            >
              <div class="driver-search-title">
                <i tooltip="Operador" class="material-icons md-90">person</i>
                {#if !compactSearchHeader || !mobileSearchOpen}
                  <span>Conductores</span>
                {/if}
              </div>
              {#if !compactSearchHeader || mobileSearchOpen}
                <div class="driver-search-shell" bind:this={driver_search_shell}>
                  <DriverListSearch
                    entries={driver_search_entries}
                    placeholder="Buscar"
                    ariaLabel="Buscar conductor"
                    on:select={(event) => {
                      selectDriverFromSearchEntry(event.detail);
                    }}
                  />
                </div>
              {/if}
              <div class="d-flex justify-content-end driver-search-actions">
                {#if !add_mode && !mapa_on_}
                  <button
                    id="add_driver"
                    on:click={add_driver}
                    type="button"
                    class="btn btn-info mini"
                    style="margin-right: 10px;"
                  >
                    <i class="material-icons" style="font-size: 20px;"
                      >add_circle_outline</i
                    >
                  </button>
                  <button
                    id="add_driver"
                    on:click={generarExcel}
                    type="button"
                    class="btn btn-info mini"
                  >
                    <i class="material-icons" style="font-size: 20px;"
                      >cloud_download
                     </i>
                  </button>
                {/if}
                {#if compactSearchHeader}
                  <button
                    type="button"
                    class="btn btn-info mini driver-search-toggle"
                    aria-label={mobileSearchOpen
                      ? "Cerrar buscador de conductores"
                      : "Abrir buscador de conductores"}
                    aria-expanded={mobileSearchOpen}
                    on:click={() => {
                      toggleMobileSearch();
                    }}
                  >
                    <i class="material-icons" style="font-size: 20px;">search</i>
                  </button>
                {/if}
              </div>
            </div>
          </div>
          <div
            class="card-body flex-grow-1 overflow-auto"
            style="border-right: 0.5px solid #80808042;display:flex;flex-direction: column;"
            bind:this={driver_list_container}
            on:dragover={(e) => {
              e.preventDefault();
              e.stopPropagation();
              file_drop = true;
            }}
            on:drop={(e) => {
              e.preventDefault();
              e.stopPropagation();
              file_drop = true;
              upload_conductores(e);
            }}
            on:dragleave={(e) => {
              e.preventDefault();
              e.stopPropagation();
              //file_drop = false;
            }}
          >
            {#if !file_drop}
              <div class="list-group">
                {#each drivers_add as item, i}
                  <a
                    href="/{item[0]}"
                    class:list-group-item-warning={selected_new == i}
                    class:active_={selected_new == i}
                    on:click|preventDefault={() => {
                      maping_new(i);
                    }}
                    class="list-group-item list-group-item-action"
                    >Nuevo chofer</a
                  >
                {/each}
                {#each $drivers_list as item, i}
                  <a
                    href="/{item[0]}"
                    data-driver-id={item[0]}
                    class:list-group-item-warning={selected == i}
                    class:active_={selected == i}
                    on:click|preventDefault={() => {
                      maping(i, true);
                    }}
                    class="list-group-item list-group-item-action"
                    >{item[1].name}</a
                  >
                {/each}
              </div>
            {:else}
              <div class="dropzone dropzone-default">
                <i
                  class="material-icons"
                  style="font-size:4.5rem; color:#217ef9;"
                >
                  cloud_upload
                </i>
                <p style="">
                  Arrastra el formato de coductores para actualizar
                </p>
              </div>
            {/if}
          </div>
        </div>
      </div>
    </div>
    <div class="col-10 h-100">
      <div class="d-flex flex-column h-100">
        <div class="card-body flex-grow-1 overflow-auto">
          <div class="row h-50 no-gutters">
            <div class="col-2 h-100">
              <div
                class="card h-100 bg-light"
                style="font-size:0.8rem; border-left:0; border-top:0;border-right:0;"
              >
                <div class="d-flex flex-column h-100 overflow-auto">
                  <div class="card-header b-0 bg-dark text-white text-center">
                    <h5>{driver_name ? driver_name : ""}</h5>
                  </div>
                  <div class="driver-photo-panel">
                    <div class="driver-photo-frame">
                      <img
                        class="img-fluid driver-photo-image"
                        src={photo_file ? photo_file : DRIVER_PHOTO_PLACEHOLDER}
                        alt="Foto del chofer"
                      />
                      {#if driver_photo_loading}
                        <div class="driver-photo-overlay">
                          {driver_photo_loading_text || "Cargando foto…"}
                        </div>
                      {/if}
                    </div>
                    <div class="driver-photo-summary">
                      {#if driver_photo_pending_action === "set"}
                        Vista previa lista para guardar
                      {:else if driver_photo_pending_action === "remove"}
                        La foto se eliminará al guardar
                      {:else if current_driver_has_photo}
                        Foto cargada
                      {:else}
                        Sin foto cargada
                      {/if}
                    </div>
                    {#if tel_edit_mode}
                      <div class="driver-photo-actions">
                        <input
                          bind:this={photoInput}
                          class="driver-photo-input"
                          type="file"
                          accept="image/jpeg,image/png,image/webp"
                          on:change={handleDriverPhotoInputChange}
                        />
                        <button
                          type="button"
                          class="btn btn-outline-info mini"
                          on:click={openDriverPhotoPicker}
                        >
                          {current_driver_has_photo || driver_photo_pending_action === "set"
                            ? "Cambiar foto"
                            : "Elegir foto"}
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-danger mini"
                          on:click={removeDriverPhoto}
                          disabled={!can_remove_driver_photo}
                        >
                          Quitar
                        </button>
                      </div>
                      <div class="driver-photo-help">
                        JPEG/PNG/WEBP · máximo 5 MB · mínimo 100x100 px. Se
                        optimiza a JPEG 320x320 y máximo 150 KB.
                      </div>
                    {/if}
                    {#if driver_photo_error}
                      <div class="driver-photo-error">{driver_photo_error}</div>
                    {/if}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-10 h-100">
              <div
                class="card h-100"
                style="font-size:0.8rem; border-top:0; border-right:0;border:0px;"
              >
                <div class="d-flex flex-column h-100">
                  <div
                    class="card-header b-0 bg-dark text-white"
                    style="display: none;"
                  >
                    <span
                      >{!mapa_on_
                        ? "Historial de viajes"
                        : "Mapa detalle"}</span
                    >
                  </div>
                  <div class="d-flex flex-grow-1 overflow-auto history-chart-panel">
                    <canvas
                      id="chart1"
                      style="display: {mapa_on_
                        ? 'none'
                        : ''};padding-top: 5px;"
                    />
                    {#if !mapa_on_ && driver_history_loading}
                      <div class="history-loading-overlay">
                        <div class="history-loading-card">
                          <div class="history-loading-title">
                            Cargando gráfica del historial…
                          </div>
                          <div class="history-loading-meta">
                            Revisados {driver_history_loaded}/{driver_history_total}
                            viajes
                          </div>
                          <div class="history-loading-meta">
                            {driver_history_matches} viajes del chofer detectados hasta ahora
                          </div>
                          <div class="history-progress">
                            <div style="width:{driver_history_progress}%;" />
                          </div>
                        </div>
                      </div>
                    {:else if !mapa_on_ && driver_id !== "" && travels_list_op.length === 0}
                      <div class="history-loading-overlay">
                        <div class="history-loading-card">
                          <div class="history-loading-title">
                            Sin viajes recientes para graficar
                          </div>
                          <div class="history-loading-meta">
                            No hay viajes completados de este chofer en los últimos 30 días.
                          </div>
                        </div>
                      </div>
                    {/if}
                    <div
                      class="h-100 w-100"
                      bind:this={route_map_host}
                      style="display: {!mapa_on_ ? 'none' : ''};"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row h-50 no-gutters">
            <div class="col-2 h-100 score-card-column">
              <div class="card h-100 score-card">
                <div
                  class="d-flex flex-column h-100 score-card-shell"
                >
                  <div
                    class="card-header b-0 bg-dark text-white score-card-header"
                    style="min-height: 26px;"
                  >
                    <span class="score-card-title">
                      <span style="vertical-align: sub;"
                        >{f_score == 1 ? "Security" : "Safety"} Score</span
                      >
                      <span
                        class="score-tooltip-trigger tooltip-wide"
                        tabindex="0"
                        role="img"
                        aria-label={f_score == 1
                          ? "Informacion sobre Security Score"
                          : "Informacion sobre Safety Score"}
                        tooltip={f_score == 1
                          ? SECURITY_SCORE_TOOLTIP
                          : SAFETY_SCORE_TOOLTIP}
                      >
                        <i class="material-icons" aria-hidden="true">help_outline</i>
                      </span>
                    </span>
                  </div>
                  <div
                    class="btn-group mx-2"
                    role="group"
                    style="margin-top:5px;"
                  >
                    <button
                      on:click|preventDefault={change_score}
                      type="button"
                      class="btn {f_score == 0
                        ? 'btn-info'
                        : 'btn-outline-info'}">Safety</button
                    >
                    <button
                      on:click|preventDefault={change_score}
                      type="button"
                      class="btn {f_score == 1
                        ? 'btn-info'
                        : 'btn-outline-info'}">Security</button
                    >
                  </div>
                  {#if f_score == 0}
                    <div
                      class=" d-flex flex-grow-1 align-items-center align-self-center"
                    >
                      <div
                        class="c100 p{score} big {score > 85
                          ? 'green'
                          : score > 50
                            ? ''
                            : 'orange'}"
                      >
                        <span>{score}</span>
                        <div class="slice">
                          <div class="bar" />
                          <div class="fill" />
                        </div>
                      </div>
                    </div>
                    <div class=" d-flex flex-grow-1">
                      <div class="table-responsive" style="overflow: hidden;">
                        <table
                          class="table table-sm"
                          style="margin-bottom: 0rem"
                        >
                          <thead>
                            <tr style="font-size: 0.55rem;">
                              <th
                                class="text-center"
                                scope="col"
                                style="vertical-align: middle;"
                                >Vuelta brusca</th
                              >
                              <th
                                class="text-center"
                                scope="col"
                                style="vertical-align: middle;"
                                >Aceleración brusca</th
                              >
                              <th
                                class="text-center"
                                scope="col"
                                style="vertical-align: middle;"
                                >Frenada brusca</th
                              >
                              <th
                                class="text-center"
                                scope="col"
                                style="vertical-align: middle;"
                                >Exceso de velocidad</th
                              >
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td class="text-center"
                                ><span
                                  class="badge badge-{vuelta > 2
                                    ? 'danger'
                                    : vuelta > 0
                                      ? 'warning'
                                      : 'secondary'}">{vuelta}</span
                                ></td
                              >
                              <td class="text-center"
                                ><span
                                  class="badge badge-{aceleracion > 2
                                    ? 'danger'
                                    : aceleracion > 0
                                      ? 'warning'
                                      : 'secondary'}">{aceleracion}</span
                                ></td
                              >
                              <td class="text-center"
                                ><span
                                  class="badge badge-{frenada > 2
                                    ? 'danger'
                                    : frenada > 0
                                      ? 'warning'
                                      : 'secondary'}">{frenada}</span
                                ></td
                              >
                              <td class="text-center"
                                ><span
                                  class="badge badge-{exceso > 2
                                    ? 'danger'
                                    : exceso > 0
                                      ? 'warning'
                                      : 'secondary'}">{exceso}</span
                                ></td
                              >
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  {/if}
                  {#if f_score == 1}
                    <div
                      class=" d-flex flex-grow-1 align-items-center align-self-center"
                    >
                      <div
                        class="c100 p{score_b} big {score_b > 85
                          ? 'green'
                          : score_b > 50
                            ? ''
                            : 'orange'}"
                      >
                        <span>{score_b}</span>
                        <div class="slice">
                          <div class="bar" />
                          <div class="fill" />
                        </div>
                      </div>
                    </div>
                  {/if}
                </div>
              </div>
            </div>
            <div class="col-4 h-100">
              <div class="card h-100">
                <div class="d-flex flex-column h-100 overflow-auto">
                  <div
                    class="card-header b-0 bg-dark text-white"
                    style="display: flex; justify-content:space-between; align-items:center; min-height:26px;"
                  >
                    <span>Datos Generales</span>
                    {#if !mapa_on_}
                      <button
                        id="edit_tel"
                        on:click={edit_tel}
                        type="button"
                        class="btn btn-info mini"
                        style="margin-left: 5px; display: {tel_edit_mode
                          ? 'none'
                          : ''};"
                      >
                        <i class="material-icons" style="font-size: 12px;"
                          >edit</i
                        >
                        Editar
                      </button>
                    {:else}
                      <!-- Button to return to driver data-->
                      <button
                        id="edit_tel"
                        on:click={() => {
                          mapa_on_ = false;
                        }}
                        type="button"
                        class="btn btn-info mini"
                        style="margin-left: 5px;"
                      >
                        <i class="material-icons" style="font-size: 12px;"
                          >arrow_back</i
                        >
                        Regresar
                      </button>
                    {/if}
                    {#if tel_edit_mode}
                      <div>
                        <button
                          id="save_Ruta"
                          on:click={save_driver}
                          type="button"
                          class="btn btn-success mini"
                        >
                          <i class="material-icons" style="font-size: 12px;"
                            >save</i
                          >
                          Guardar
                        </button>
                        <button
                          id="cancel_save_destino"
                          on:click={cancelDriverEdit}
                          type="button"
                          style="margin-left: 5px;"
                          class="btn btn-danger mini"
                        >
                          <i class="material-icons" style="font-size: 12px;"
                            >cancel</i
                          >
                          Cancelar
                        </button>
                      </div>
                    {/if}
                  </div>
                  <div class=" d-flex flex-grow-1 pt-0" style="overflow: auto;">
                    {#if !mapa_on_}
                      <div class="table-responsive">
                        <table
                          class="table table-sm table-striped"
                          style="margin-bottom: 0rem;height: 100%;"
                        >
                          <tbody>
                            <tr>
                              <!--Driver id-->
                              <th scope="row" class="dato-general">
                                <div style="display: flex;align-items: center;">
                                  <i
                                    class="material-icons"
                                    style="font-size: 24px;margin-right: 5px;"
                                    >assignment_ind</i
                                  >
                                  ID
                                </div>
                              </th>
                              <th class="dato-general">{driver_id.slice(-6)}</th
                              >
                            </tr>
                            <tr>
                              <th scope="row" class="dato-general">
                                <div style="display: flex;align-items: center;">
                                  <i
                                    class="material-icons"
                                    style="font-size: 24px;margin-right: 5px;"
                                    >person</i
                                  >
                                  Nombre
                                </div>
                              </th>
                              {#if tel_edit_mode}
                                <td class="dato-general" style="color:#2196f3">
                                  <input
                                    type="text"
                                    size="20"
                                    maxlength="50"
                                    bind:value={driver_name}
                                  />
                                </td>
                              {:else}
                                <td class="dato-general">{driver_name}</td>
                              {/if}
                            </tr>
                            <tr>
                              <th scope="row" class="dato-general">
                                <div style="display: flex;align-items: center;">
                                  <i
                                    class="material-icons"
                                    style="font-size: 24px;margin-right: 5px;"
                                    >phone</i
                                  >
                                  Teléfono
                                </div>
                              </th>
                              {#if !tel_edit_mode}
                                <td
                                  class="dato-general"
                                  style="color:#2196f3;cursor:pointer;"
                                  on:click={() => {
                                    //copy to clipboard
                                    navigator.clipboard.writeText(tel);
                                    // show message of copy
                                    saved_type = "alert-success";
                                    saved_text = "Teléfono copiado";
                                    saved_ok = true;
                                    setTimeout(function () {
                                      saved_ok = false;
                                    }, 3000);
                                  }}>{tel}</td
                                >
                              {:else}
                                <td class="dato-general" style="color:#2196f3">
                                  <input
                                    type="text"
                                    size="10"
                                    maxlength="10"
                                    bind:value={tel_new}
                                  />
                                </td>
                              {/if}
                            </tr>
                            <tr>
                              <th scope="row" class="dato-general">
                                <div style="display: flex;align-items: center;">
                                  <i
                                    class="material-icons"
                                    style="font-size: 24px;margin-right: 5px;"
                                    >account_circle</i
                                  >
                                  Usuario
                                </div>
                              </th>
                              {#if !tel_edit_mode}
                                <td
                                  class="dato-general"
                                  style="color:rgb(0 64 253);cursor:pointer;"
                                  on:click={() => {
                                    //copy to clipboard
                                    navigator.clipboard.writeText(
                                      usuario + "_@" + $group
                                    );
                                    // show message of copy
                                    saved_type = "alert-success";
                                    saved_text = "Usuario copiado";
                                    saved_ok = true;
                                    setTimeout(function () {
                                      saved_ok = false;
                                    }, 3000);
                                  }}
                                  >{usuario}{usuario != ""
                                    ? "_@" + $group
                                    : ""}</td
                                >
                              {:else}
                                <td
                                  class="dato-general"
                                  style="color:rgb(0 64 253)"
                                >
                                  <div
                                    style="display: flex;align-items: center;"
                                  >
                                    <input
                                      type="text"
                                      size="10"
                                      maxlength="50"
                                      bind:value={usuario_new}
                                    />_@{$group}
                                  </div>
                                </td>
                              {/if}
                            </tr>
                            <tr>
                              <th scope="row" class="dato-general">
                                <div style="display: flex;align-items: center;">
                                  <i
                                    class="material-icons"
                                    style="font-size: 24px;margin-right: 5px;"
                                    >vpn_key</i
                                  >
                                  Contraseña
                                </div>
                              </th>
                              {#if !tel_edit_mode}
                                <td class="dato-general"
                                  >{usuario != "-" ? "•••••••••" : "-"}
                                </td>
                              {:else}
                                <td class="dato-general" style="color:#2196f3">
                                  <input
                                    type="password"
                                    size="10"
                                    maxlength="20"
                                    bind:value={password_new}
                                  />
                                </td>
                              {/if}
                            </tr>
                            <tr>
                              <th scope="row" class="dato-general">
                                <div style="display: flex;align-items: center;">
                                  <i
                                    class="material-icons"
                                    style="font-size: 24px;margin-right: 5px;"
                                    >chat</i
                                  >
                                  Tipo de chat
                                </div>
                              </th>
                              {#if !tel_edit_mode}
                                <td class="dato-general">{chatType} </td>
                              {:else}
                                <td class="dato-general" style="color:#2196f3">
                                  <select
                                    name="chat_type"
                                    bind:value={chatType}
                                  >
                                    <option value="Niguno">Niguno</option>
                                    <option value="Telegram APP"
                                      >Telegram APP</option
                                    >
                                    <option value="OT Drive">OT Drive</option>
                                    <option value="Vector Messenger"
                                      >Vector Messenger</option
                                    >
                                    <option value="Web App">Web App</option>
                                  </select>
                                </td>
                              {/if}
                            </tr>
                            <tr>
                              <th scope="row" class="dato-general">
                                <div style="display: flex;align-items: center;">
                                  <i
                                    class="material-icons"
                                    style="font-size: 24px;margin-right: 5px;"
                                    >tag
                                  </i>
                                  ChatId
                                </div>
                              </th>
                              {#if !tel_edit_mode}
                                <td class="dato-general" style="color:#2196f3"
                                  >{chatId}</td
                                >
                              {:else}
                                <td class="dato-general" style="color:#2196f3">
                                  <input
                                    type="text"
                                    size="20"
                                    maxlength="20"
                                    bind:value={chatId_new}
                                  />
                                </td>
                              {/if}
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    {:else}
                      <div class="table-responsive">
                        <table
                          class="table table-sm table-striped"
                          style="margin-bottom: 0rem;height: 100%;"
                        >
                          <tbody>
                            <tr>
                              <th scope="row" class="text-center"
                                >Inicio real</th
                              >
                              <td class="text-center">{fecha_now}</td>
                            </tr>
                            <tr>
                              <th scope="row" class="text-center">Unidad</th>
                              <td class="text-center">{unidad_now}</td>
                            </tr>
                            <tr>
                              <th scope="row" class="text-center">Origen</th>
                              <td class="text-center">{origen_now}</td>
                            </tr>
                            <tr>
                              <th scope="row" class="text-center">Destino</th>
                              <td class="text-center">{destino_now}</td>
                            </tr>
                            <tr>
                              <th scope="row" class="text-center">Duración</th>
                              <td class="text-center">{duracion_now}</td>
                            </tr>
                            <tr>
                              <th scope="row" class="text-center">Distancia</th>
                              <td class="text-center"
                                >{Math.round(total_dist)}km</td
                              >
                            </tr>
                            <tr>
                              <th scope="row" class="text-center">Alertas</th>
                              <td class="text-center">{alertas_now}</td>
                            </tr>
                            <tr>
                              <th scope="row" class="text-center"
                                >Tiempo de manejo</th
                              >
                              <td class="text-center"
                                >{time_code_s(time_travel)}</td
                              >
                            </tr>
                            <tr>
                              <th scope="row" class="text-center"
                                >Tiempo en idle</th
                              >
                              <td class="text-center"
                                >{time_code_s(time_idle)}</td
                              >
                            </tr>
                            <tr>
                              <th scope="row" class="text-center"
                                >Tiempo en apagada</th
                              >
                              <td class="text-center"
                                >{time_code_s(time_off)}</td
                              >
                            </tr>
                            <tr>
                              <th scope="row" class="text-center"
                                >Numero de paradas</th
                              >
                              <td class="text-center">{paradas_now}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    {/if}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6 h-100">
              {#if !mapa_on_}
                <div class="card h-100" style="font-size:0.8rem;">
                  <div class="d-flex flex-column h-100 overflow-auto">
                    <div
                      class="card-header b-0 bg-dark text-white"
                      style="min-height: 26px;"
                    >
                      <span style="vertical-align: sub; font-size:0.85rem;"
                        >Lista de viajes</span
                      >
                    </div>
                    <div class="history-status">
                      {#if driver_history_loading}
                        <span>
                          Cargando viajes… {driver_history_loaded}/{driver_history_total}
                        </span>
                        <span>{driver_history_matches} encontrados</span>
                      {:else if driver_id !== ""}
                        <span>
                          {travels_list_op.length} viajes del chofer en los últimos 30 días
                        </span>
                      {/if}
                    </div>
                    {#if driver_history_loading}
                      <div class="history-progress history-progress-strip">
                        <div style="width:{driver_history_progress}%;" />
                      </div>
                    {/if}
                    <div
                      class=" d-flex flex-grow-1 pt-0"
                      style="overflow: auto;"
                    >
                      {#if driver_history_loading && travels_list_op.length === 0}
                        <div class="history-empty">
                          <i class="material-icons md-36 bblue">hourglass_top</i>
                          <strong>Preparando lista de viajes…</strong>
                          <span>
                            La tabla se llenará por bloques conforme se procese el historial.
                          </span>
                        </div>
                      {:else if driver_id !== "" && travels_list_op.length === 0}
                        <div class="history-empty">
                          <i class="material-icons md-36 gray">info</i>
                          <strong>Sin viajes recientes</strong>
                          <span>
                            Este chofer no tiene viajes completados en los últimos 30 días.
                          </span>
                        </div>
                      {:else}
                        <table
                          class="table table-sm table-striped"
                          style="margin-bottom: 0rem"
                        >
                          <thead
                            style="position: sticky; top:0px;background-color: white;"
                          >
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Fecha</th>
                              <th scope="col">Unidad</th>
                              <th scope="col">Origen</th>
                              <th scope="col">Destino</th>
                              <th scope="col">Duración</th>
                              <th scope="col">Alertas</th>
                            </tr>
                          </thead><tbody>
                            {#each travels_list_op as item, i}
                              <tr>
                                <th scope="row">{i + 1}</th>
                                <td>
                                  <a
                                    href="/{item[9]}"
                                    on:click|preventDefault={() => {
                                      get_travel(item[6], item[7], item[8], item);
                                    }}>{item[0]}</a
                                  >
                                </td>
                                <td>{item[1]}</td>
                                <td>{item[2]}</td>
                                <td>{item[3]}</td>
                                <td>{item[4]}</td>
                                <td>
                                  {#if item[5] > 0}
                                    <a
                                      href="/"
                                      on:click|preventDefault={() => {
                                        get_alerts(item[6], item[10]);
                                      }}
                                    >
                                      {item[5]}
                                    </a>
                                  {:else}
                                    {item[5]}
                                  {/if}
                                </td>
                              </tr>
                            {/each}
                          </tbody>
                        </table>
                      {/if}
                    </div>
                  </div>
                </div>
              {/if}
              <div
                class="card h-100"
                style="font-size:0.8rem;display: {!mapa_on_ ? 'none' : ''};"
              >
                <div class="d-flex flex-column h-50 overflow-auto">
                  <div class="card-header b-0 bg-dark text-white">
                    <strong>HOS</strong>
                  </div>
                  <div class=" d-flex flex-grow-1 pt-0">
                    <canvas
                      id="chart2"
                      style="display: {!mapa_on_ ? 'none' : ''};"
                    />
                  </div>
                </div>
                <div class="d-flex flex-column h-50 overflow-auto">
                  <div class="card-header b-0 bg-dark text-white">
                    <strong>Tiempo por estado</strong>
                  </div>
                  <div class=" d-flex flex-grow-1 pt-0">
                    <canvas
                      id="chart3"
                      style="display: {!mapa_on_ ? 'none' : ''};"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<style>
  .btn {
    font-size: 0.75rem;
    padding: 0.1rem, 0.1rem;
    line-height: 0.7;
  }
  .card-body {
    padding-top: 0rem;
    padding-right: 0rem;
    padding-bottom: 0rem;
    padding-left: 0rem;
  }
  .card-header.b-0 {
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
    padding-left: 0.75rem;
  }
  .score-card-header {
    display: flex;
    align-items: center;
  }
  .score-card-column {
    position: relative;
    z-index: 0;
    isolation: isolate;
  }
  .score-card {
    position: relative;
    z-index: 0;
  }
  .score-card-shell {
    position: relative;
    overflow: visible;
  }
  .score-card-title {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
  }
  .score-tooltip-trigger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 0.88);
    cursor: help;
    line-height: 1;
  }
  .score-tooltip-trigger .material-icons {
    font-size: 0.95rem;
  }
  .card-b {
    border: 0px;
  }
  .bg-dark2 {
    background-color: #009688;
  }
  .bg-secondary2 {
    background-color: #b2dfdb;
  }
  .c100.big {
    font-size: 11vw;
  }
  .c100 {
    margin: 0;
  }
  .c100 > span {
    width: 2.5em;
    line-height: 2.5em;
    font-size: 0.4em;
  }
  .badge {
    font-size: 1.5rem;
  }
  .card-header:first-child {
    border-radius: 0;
  }
  .driver-search-header {
    display: flex;
    align-items: center;
    gap: 0.45rem;
    position: relative;
    overflow: visible;
  }
  .driver-search-title {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    line-height: 1.2;
    flex-shrink: 0;
  }
  .driver-search-shell {
    flex: 1 1 auto;
    min-width: 0;
    max-width: 9.75rem;
  }
  .driver-search-actions {
    flex-shrink: 0;
  }
  .driver-search-toggle {
    margin-left: 0.35rem;
  }
  .driver-search-header--compact {
    gap: 0.35rem;
  }
  .driver-search-header--compact .driver-search-shell {
    max-width: none;
  }
  .driver-search-header--compact-open .driver-search-title {
    gap: 0;
  }

  .btn.mini {
    vertical-align: initial;
    padding: 1px 6px;
    font-size: 0.78rem;
  }
  .alert-top {
    position: fixed;
    top: 3rem;
    left: 35%;
    width: 30%;
    z-index: 1050;
  }

  [tooltip] {
    position: relative;
  }
  [tooltip]:before {
    content: attr(tooltip);
    position: absolute;
    bottom: -25px;
    left: 50%;
    padding: 8px;
    transform: translateX(-50%) scale(0);
    transform-origin: top;
    background: #757575;
    color: white;
    border-radius: 2px;
    font-size: 0.6rem;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    z-index: 1;
  }
  [tooltip]:hover:before {
    transform: translateX(-50%) scale(1);
  }
  .tooltip-wide[tooltip]:before {
    bottom: auto;
    top: calc(100% + 6px);
    left: 0;
    width: max-content;
    max-width: min(240px, 70vw);
    font-size: 0.72rem;
    white-space: normal;
    line-height: 1.35;
    text-align: left;
    z-index: 5;
    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.18);
    pointer-events: none;
    transform: translateX(0) scale(0);
    transform-origin: top left;
  }
  .tooltip-wide[tooltip]:hover:before,
  .tooltip-wide[tooltip]:focus:before,
  .tooltip-wide[tooltip]:focus-visible:before {
    transform: translateX(0) scale(1);
  }

  @font-face {
    font-family: "Material Icons";
    font-style: normal;
    font-weight: 400;
    src: url(../css/flUhRq6tzZclQEJ-Vdg-IuiaDsNc.woff2) format("woff2");
  }
  .material-icons {
    font-family: "Material Icons";
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: "liga";
    -webkit-font-smoothing: antialiased;
  }
  .material-icons.md-1 {
    font-size: 1.1rem;
  }
  .material-icons.md-18 {
    font-size: 18px;
  }
  .material-icons.md-24 {
    font-size: 24px;
  }
  .material-icons.md-36 {
    font-size: 36px;
  }
  .material-icons.md-48 {
    font-size: 48px;
  }
  .material-icons.md-85 {
    font-size: 1.3rem;
  }
  .material-icons.md-90 {
    font-size: 1.5rem;
  }
  .material-icons.md-dark {
    color: rgba(0, 0, 0, 0.54);
  }
  .material-icons.md-dark.md-inactive {
    color: rgba(0, 0, 0, 0.26);
  }
  .material-icons.md-light {
    color: rgba(255, 255, 255, 1);
  }
  .material-icons.md-light.md-inactive {
    color: rgba(255, 255, 255, 0.3);
  }
  .material-icons.orange {
    color: #ff7043;
  }
  .material-icons.bblue {
    color: #26a69a;
  }
  .material-icons.green {
    color: rgb(24, 179, 45);
  }
  .material-icons.yei {
    color: #ff9800;
  }
  .material-icons.golden {
    color: #856404;
  }
  .material-icons.gray {
    color: #525a63;
  }
  .material-icons.red {
    color: #df1616;
  }
  i {
    vertical-align: middle;
    padding-bottom: 3px;
  }
  span.blue {
    color: rgb(17, 33, 255);
  }
  th.dato-general,
  td.dato-general {
    text-align: start;
    vertical-align: middle;
    font-size: 0.9rem;
    padding-left: 0.75rem;
  }
  .dropzone-default {
    background-color: aliceblue;
    border: 2px dashed #ccc;
    padding: 20px;
    text-align: center;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 10px;
  }
  .history-chart-panel {
    position: relative;
  }
  .history-loading-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    background: rgba(255, 255, 255, 0.82);
    z-index: 2;
  }
  .history-loading-card {
    width: min(340px, 100%);
    padding: 0.9rem 1rem;
    border: 1px solid #d9e2ec;
    border-radius: 0.5rem;
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 6px 18px rgba(15, 23, 42, 0.08);
    text-align: center;
  }
  .history-loading-title {
    font-size: 0.95rem;
    font-weight: 600;
    color: #1f2937;
  }
  .history-loading-meta {
    margin-top: 0.35rem;
    font-size: 0.78rem;
    color: #64748b;
  }
  .history-status {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 0.35rem 0.75rem;
    padding: 0.45rem 0.75rem;
    border-bottom: 1px solid #e2e8f0;
    font-size: 0.78rem;
    color: #64748b;
  }
  .history-progress {
    width: 100%;
    height: 6px;
    background: #e2e8f0;
    border-radius: 999px;
    overflow: hidden;
    margin-top: 0.75rem;
  }
  .history-progress > div {
    height: 100%;
    background: #2196f3;
    transition: width 0.3s ease;
  }
  .history-progress-strip {
    margin-top: 0;
    border-radius: 0;
    height: 3px;
    background: #e0e0e0;
  }
  .history-empty {
    display: flex;
    flex: 1;
    min-height: 160px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.35rem;
    padding: 1rem;
    text-align: center;
    color: #64748b;
  }
  .history-empty strong {
    color: #1f2937;
    font-size: 0.92rem;
  }
  .driver-photo-panel {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 0.6rem;
    padding: 0.75rem;
  }
  .driver-photo-frame {
    position: relative;
    display: flex;
    flex: 1;
    min-height: 190px;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border: 1px solid #d8dee4;
    border-radius: 0.75rem;
    background: #ffffff;
  }
  .driver-photo-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .driver-photo-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.75rem;
    text-align: center;
    background: rgba(15, 23, 42, 0.45);
    color: #ffffff;
    font-size: 0.82rem;
    font-weight: 600;
  }
  .driver-photo-summary {
    font-size: 0.78rem;
    color: #475569;
    text-align: center;
  }
  .driver-photo-actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.35rem;
  }
  .driver-photo-help {
    font-size: 0.72rem;
    color: #64748b;
    text-align: center;
    line-height: 1.35;
  }
  .driver-photo-error {
    padding: 0.45rem 0.55rem;
    border-radius: 0.5rem;
    background: #fee2e2;
    color: #b91c1c;
    font-size: 0.74rem;
    line-height: 1.35;
    text-align: center;
  }
  .driver-photo-input {
    display: none;
  }
</style>
